/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";
import { string, object, array } from "prop-types";

import Headline from "../../atoms/headline";
import SmallHorizontalCard from "../../molecules/small-horizontal-card";
import DfpAd from "../../dfp-ad/index";

import { getSlug } from "../../utils";

import "./section.m.css";

class SideBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();
  }

  getFilteredStories = collection => {
    const filteredCollection =
      (collection && collection.items && collection.items.length > 0 && collection.items.filter(item => item.story)) ||
      [];
    if (filteredCollection.length > 0 && collection.slug === "trending") {
      filteredCollection.sort((a, b) => b.story["published-at"] - a.story["published-at"]);
    }
    const filteredStories = filteredCollection.filter(item => item.story["story-template"] !== "horoscope").slice(0, 5);
    return filteredStories;
  };

  getSidebarCollection = (filteredStories, collection) => {
    const slug = getSlug(collection, this.props.sections);
    return collection.items && collection.items.length > 0 && collection.slug !== this.props.currentSection ? (
      <div styleName="wrapper">
        {collection.name && filteredStories.length > 0 ? (
          <div styleName="collection-name">
            <Link href={slug}>
              <Headline text={collection.name} headerType={13} headerLevel={3} />
            </Link>
          </div>
        ) : null}
        {filteredStories &&
          filteredStories.map((item, index) => (
            <Link href={`/${item.story.slug}`} key={index}>
              <SmallHorizontalCard story={item.story} key={index} />
            </Link>
          ))}
      </div>
    ) : null;
  };
  render() {
    const {
      trendingCollection,
      webSpecialCollection,
      opinionsCollection,
      horoscopeCollection,
      viralCollection
    } = this.props;

    const filteredTrendingStories = this.getFilteredStories(trendingCollection);
    const filteredWebSpecialStories = this.getFilteredStories(webSpecialCollection);
    const filteredOpinionsCollection = this.getFilteredStories(opinionsCollection);
    const filteredHoroscopeCollection = horoscopeCollection && horoscopeCollection.items;
    const filteredViralCollection = this.getFilteredStories(viralCollection);

    return (
      <React.Fragment>
        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="rectangle_0_300x250" />
        </div>
        {this.getSidebarCollection(filteredTrendingStories, trendingCollection)}

        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="rectangle_1_300x250" />
        </div>

        {this.getSidebarCollection(filteredWebSpecialStories, webSpecialCollection)}

        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="rectangle_0_300x250" />
        </div>

        {this.getSidebarCollection(filteredOpinionsCollection, opinionsCollection)}
        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="rectangle_1_300x250" />
        </div>
        {this.getSidebarCollection(
          filteredHoroscopeCollection && filteredHoroscopeCollection.slice(0, 1),
          horoscopeCollection
        )}

        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="rectangle_0_300x250" />
        </div>

        {this.getSidebarCollection(filteredViralCollection, viralCollection)}

        <div styleName="dfp-ad-300x250">
          <DfpAd adtype="rectangle_1_300x250" />
        </div>
      </React.Fragment>
    );
  }
}

SideBar.propTypes = {
  currentSection: string,
  trendingCollection: object,
  webSpecialCollection: object,
  opinionsCollection: object,
  horoscopeCollection: object,
  viralCollection: object,
  sections: array
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(SideBar);
